// src/api/api.js
import axios from 'axios';

// Utiliser la variable d'environnement
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const tables = {
  users: 'tables/users',
  publications: 'tables/publications',
  news: 'tables/news',
  messages: 'tables/messages',
  newsletter_subscribers: 'tables/newsletter_subscribers',
};

export const getTable = async (table, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `${table}${query ? '?' + query : ''}`;
  const res = await api.get(url);
  return res.data;
};

export const getTableItem = async (table, id) => {
  const res = await api.get(`${table}/${id}`);
  return res.data;
};

export const postTable = async (table, data) => {
  const res = await api.post(table, data);
  return res.data;
};

export const patchTable = async (table, id, data) => {
  const res = await api.patch(`${table}/${id}`, data);
  return res.data;
};

export const deleteTable = async (table, id) => {
  const res = await api.delete(`${table}/${id}`);
  return res.data;
};